import moment from 'moment-timezone';
import {
    INITIAL_LOAD,
    LOAD_TRACKING_DATA_FOR_DASHBOARD,
    REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR,
    REQUEST_TRACKING_STATS_FAILED,
    REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS,
    REQUEST_WORKOUT_STATS,
    REQUEST_WORKOUT_STATS_SUCCESS,
    REQUEST_SCAN_STATS,
    REQUEST_SCAN_STATS_SUCCESS,
    REQUEST_SCAN_STAT_DATES_SUCCESS,
    REQUEST_LATEST_SCAN_STATS,
    REQUEST_LATEST_SCAN_STATS_SUCCESS,
    RELOAD_SCAN_STATS_FOR_DASHBOARD,
    SET_SELECTED_SCAN_STATS_DATE,
    REQUEST_WORKOUT_STATS_FAILED,
    REQUEST_SCAN_STATS_FAILED,
    REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS,
    REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED,
    REQUEST_WEEKLY_WORKOUT_STATS_REQUEST,
    REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS,
    REQUEST_WEEKLY_WORKOUT_STATS_FAILURE,
    REQUEST_BODY_METRIC_STATS_REQUEST,
    REQUEST_BODY_METRIC_STATS_SUCCESS,
    REQUEST_BODY_METRIC_STATS_FAILURE,
    LOAD_LEADERBOARDS_REQUEST,
    LOAD_LEADERBOARDS_SUCCESS,
    LOAD_LEADERBOARDS_FAILURE,
    LOAD_INACTIVE_LEADERBOARDS_REQUEST,
    LOAD_INACTIVE_LEADERBOARDS_SUCCESS,
    LOAD_INACTIVE_LEADERBOARDS_FAILURE,
    LOAD_USER_BREAKDOWN_REQUEST,
    LOAD_USER_BREAKDOWN_SUCCESS,
    LOAD_USER_BREAKDOWN_FAILURE,
    OPT_OUT_OF_LEADERBOARD,
    OPT_OUT_OF_LEADERBOARD_REQUEST,
    OPT_OUT_OF_LEADERBOARD_FAILURE,
    OPT_OUT_OF_LEADERBOARD_SUCCESS,
    CLOSE_OPT_OUT_LEADERBOARD_MODAL,
} from './actionTypes';
import { REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS } from '../BodyScale/actionTypes.ts';
import { REMOVE_TARGET_SUCCESS } from '../WeightTarget/actionTypes';
import { makeDates } from './../utils';

const buildWorkoutHeaderDateRange = (now, selected) => {
    if (selected) {
        const monthSelected = selected.format('MMM');
        let endDate = selected.isSame(now, 'month') ? now : selected.endOf('month');
        return `1 ${monthSelected} to ${endDate.format('D')} ${endDate.format('MMM')} ${endDate.format('Y')}`;
    }
    const monthNow = now.format('MMM');
    return `1 ${monthNow} to ${now.format('D')} ${monthNow} ${now.format('Y')}`;
}

export default (state = {
    view: {
        isLoading: true,
        isLoadingWorkout: true,
        isLoadingHealth: true,
        isLoadingNutrition: true,
        isLoadingNutritionWeeklyStats: true,
        isLoadingWeeklyWorkoutProgress: true,
        workoutLoadError: null,
        healthLoadError: null,
        bodyMetricStatsLoadError: null,
        nutritionLoadError: null,
        nutritionWeeklyStatsLoadError: null,
        weeklyWorkoutProgressError: null,
        isInitialScanStatsLoad: null,
        error: null, // string
        monthAndYearRange: null, // month and year for the past 2 years for dropdown
        selectedMonthAndYear: null, // date object or string or something else? (Initial todays month and year?)
        workoutHeaderDateRange: null, // string 1 Jan to 9 Jan
        lastScanDate: null,
        scanStatDates: null,
        selectedScanStatDate: null,
        dashboard: {
            workoutDateRange: null,
        },
        weeklyWorkoutStatsIsLoading: false,
        bodyMetricStatsIsLoading: true,
        isLoadingLeaderboards: false,
        loadingLeaderboardsError: null,
        isLoadingInactiveLeaderboards: false,
        loadingInactiveLeaderboardsError: null,
        isLeaderboardOptOutModalVisible: false,
        isOptingOutOfLeaderboard: false,
        isLoadingUserBreakdown: true,
    },
    data: {
        stats: null,
        scanStats: null,
        workoutStats: null,
        nutritionStats: null,
        weeklyWorkoutProgress: null,
        dashboard: {
            stats: null,
            scanStats: null,
            workoutStats: null,
            nutritionStats: null,
            nutritionWeeklyStats: null,
        },
        weeklyWorkoutStats: null,
        hasLastWorkout: false,
        lastWorkoutHasMetrics: false,
        effortPointGraphYMax: 0,
        bodyMetricStats: {},
        bodyMetricSet: [],
        leaderboards: null,
        completedLeaderboards: null,
        leaderboardToOptOutOf: null,
        userLeaderboardBreakdown: null,
    },
},              action) => {
    switch (action.type) {
        case INITIAL_LOAD: {
            const dateNow = action.payload.now;
            const selectedMonthAndYear = { value: moment(dateNow).format('YYYY-MM'), displayName: moment(dateNow).format('MMMM') + ', ' + dateNow.getFullYear() };
            let monthAndYearRange = [];
            const dateEnd = moment(dateNow);
            const dateStart = dateEnd.clone().subtract(2, 'year');
            while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                monthAndYearRange = [{ value: moment(dateStart).format('YYYY-MM'), displayName: dateStart.format('MMMM') + ', ' + dateStart.format('YYYY') }, ...monthAndYearRange];
                dateStart.add(1, 'month');
            }
            const workoutHeaderDateRange = buildWorkoutHeaderDateRange(dateEnd);
            return {
                view: {
                    ...state.view,
                    isLoading: true,
                    isInitialScanStatsLoad: null,
                    monthAndYearRange,
                    selectedMonthAndYear,
                    workoutHeaderDateRange,
                    selectedScanStatDate: null,
                    dashboard: {
                        workoutDateRange: workoutHeaderDateRange
                    }
                },
                data: {
                    ...state.data,
                    stats: null,
                    scanStats: null,
                    workoutStats: null
                }
            }
        }
        case REQUEST_TRACKING_STATS_FOR_MONTH_AND_YEAR: {
            const { month, year } = action.payload;
            const normalDate = new Date(year, month - 1);
            const selected = moment(normalDate);
            const selectedMonthAndYear = { value: moment(`${year}-${month}`).format('YYYY-MM'), displayName: selected.format('MMMM') + ', ' + selected.format('YYYY') };
            const now = moment(action.payload.now);
            const workoutHeaderDateRange = buildWorkoutHeaderDateRange(now, selected);

            return {
                view: {
                    ...state.view,
                    isLoading: true,
                    selectedMonthAndYear,
                    workoutHeaderDateRange,
                },
                data: {
                    ...state.data,
                    stats: null,
                    scanStats: null,
                    workoutStats: null
                }
            };
        }
        case REQUEST_WORKOUT_STATS: {
            const { month, year } = action.payload;
            const normalDate = new Date(year, month - 1);
            const selected = moment(normalDate);
            const selectedMonthAndYear = { value: moment(`${year}-${month}`).format('YYYY-MM'), displayName: selected.format('MMMM') + ', ' + selected.format('YYYY') };
            const now = moment(action.payload.now);
            const workoutHeaderDateRange = buildWorkoutHeaderDateRange(now, selected);
            return {
                view: {
                    ...state.view,
                    isLoading: true,
                    selectedMonthAndYear,
                    workoutHeaderDateRange,
                },
                data: {
                    ...state.data,
                }
            }
        }
        case REQUEST_WORKOUT_STATS_SUCCESS: {
            const stats = {
                totals: action.payload.workoutStats.totals,
                muscleGroupPercentages: action.payload.workoutStats.muscleGroupPercentages
            };
            const workoutStats = action.payload.workoutStats && Object.keys(action.payload.workoutStats)
                .filter(key => !Object.keys(stats).includes(key))
                .map(key => action.payload.workoutStats[key]);
            return {
                view: {
                    ...state.view,
                    isLoading: false,
                },
                data: {
                    ...state.data,
                    stats,
                    workoutStats
                }
            };
        }
        case SET_SELECTED_SCAN_STATS_DATE: {
            const selectedScanStatDate = moment(action.payload.date).format('D MMMM YYYY');

            return {
                view: {
                    ...state.view,
                    selectedScanStatDate,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_LATEST_SCAN_STATS: {
            const selectedScanStatDate = moment(action.payload.date).format('D MMMM YYYY');
            return {
                view: {
                    ...state.view,
                    isLoading: true,
                    isInitialScanStatsLoad: true,
                    selectedScanStatDate
                },
                data: {
                    ...state.data,
                }
            }
        }
        case REQUEST_LATEST_SCAN_STATS_SUCCESS: {
            const scanStats = action.payload.scanStats && [action.payload.scanStats.fat, action.payload.scanStats.muscleMass, action.payload.scanStats.totalBodyWeight];
            const lastScanDate = (action.payload.scanStats && action.payload.scanStats.scanDate) && moment(action.payload.scanStats.scanDate).format('DD MMM YYYY');
            return {
                view: {
                    ...state.view,
                    isLoading: false,
                    isInitialScanStatsLoad: false,
                    lastScanDate,
                },
                data: {
                    ...state.data,
                    scanStats
                }
            }
        }
        case REQUEST_SCAN_STATS: {
            const selectedScanStatDate = moment(action.payload.date).format('YYYY-MM-DD');
            return {
                view: {
                    ...state.view,
                    isLoading: true,
                    selectedScanStatDate
                },
                data: {
                    ...state.data,
                }
            }
        }
        case REQUEST_SCAN_STATS_SUCCESS: {
            if (state.view.isInitialScanStatsLoad) {
                return {
                    ...state,
                };
            }

            const scanStats = action.payload.scanStats && [action.payload.scanStats.fat, action.payload.scanStats.muscleMass, action.payload.scanStats.totalBodyWeight];
            const lastScanDate = (action.payload.scanStats && action.payload.scanStats.scanDate) && moment(action.payload.scanStats.scanDate).format('DD MMM YYYY');
            return {
                view: {
                    ...state.view,
                    isLoading: false,
                    lastScanDate,
                },
                data: {
                    ...state.data,
                    scanStats
                }
            }
        }
        case REQUEST_TRACKING_STATS_FAILED: {
            return {
                view: {
                    ...state.view,
                    isLoading: false,
                    error: action.payload
                },
                data: {
                    ...state.data,
                    stats: null,
                    scanStats: null,
                    workoutStats: null
                }
            }
        }
        case REQUEST_WORKOUT_STATS_FOR_DASHBOARD_SUCCESS: {
            const stats = {
                totals: action.payload.workoutStats.totals,
                muscleGroupPercentages: action.payload.workoutStats.muscleGroupPercentages,
            };
            const workoutStats = action.payload.workoutStats &&
                Object.keys(action.payload.workoutStats).map(key => action.payload.workoutStats[key]);

            return {
                view: {
                    ...state.view,
                    isLoadingWorkout: false,
                    workoutLoadError: null,
                },
                data: {
                    ...state.data,
                    dashboard: {
                        ...state.data.dashboard,
                        stats,
                        workoutStats,
                    },
                },
            };
        }
        case REQUEST_WORKOUT_STATS_FAILED: {
            return {
                view: {
                    ...state.view,
                    isLoadingWorkout: false,
                    workoutLoadError: action.payload,
                },
                data: {
                    ...state.data,
                    dashboard: {
                        ...state.data.dashboard,
                        stats: null,
                        workoutStats: null,
                    },
                },
            };
        }
        case REQUEST_SCAN_STATS_FAILED: {
            return {
                view: {
                    ...state.view,
                    isLoadingHealth: false,
                    healthLoadError: action.payload,
                },
                data: {
                    ...state.data,
                    dashboard: {
                        ...state.data.dashboard,
                        scanStats: null,
                    },
                },
            };
        }
        case REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_SUCCESS: {
            const weeklyWorkoutProgress = action.payload;
            return {
                view: {
                    ...state.view,
                    isLoadingWeeklyWorkoutProgress: false,
                    weeklyWorkoutProgressError: null,
                },
                data: {
                    ...state.data,
                    weeklyWorkoutProgress,
                },
            };
        }
        case REQUEST_WEEKLY_WORKOUT_PROGRESS_FOR_GRAPH_FAILED: {
            const weeklyWorkoutProgressError = action.payload;
            return {
                view: {
                    ...state.view,
                    isLoadingWeeklyWorkoutProgress: false,
                    weeklyWorkoutProgressError,
                },
                data: {
                    ...state.data,
                    weeklyWorkoutProgress: null,
                },
            };
        }
        case REQUEST_WEEKLY_WORKOUT_STATS_REQUEST: {
            return {
                view: {
                    ...state.view,
                    weeklyWorkoutStatsIsLoading: true,
                },
                data: {
                    ...state.data,
                    weeklyWorkoutStats: null,
                    hasLastWorkout: false,
                    lastWorkoutHasMetrics: false,
                },
            };
        }
        case REQUEST_WEEKLY_WORKOUT_STATS_SUCCESS: {
            const weeklyWorkoutStats = action.payload;
            const hasLastWorkout = weeklyWorkoutStats
                && weeklyWorkoutStats.lastWorkoutStats
                && weeklyWorkoutStats.lastWorkoutStats.lastWorkoutDetails;
            const lastWorkoutHasMetrics = !!(hasLastWorkout
                && weeklyWorkoutStats.lastWorkoutStats.effortPoints
                && weeklyWorkoutStats.lastWorkoutStats.calories
                && weeklyWorkoutStats.lastWorkoutStats.averageHeartRate);
            const effortYMax = Math.max(...weeklyWorkoutStats.weeklyEffortPoints.graphData);

            return {
                view: {
                    ...state.view,
                    weeklyWorkoutStatsIsLoading: false,
                },
                data: {
                    ...state.data,
                    weeklyWorkoutStats,
                    hasLastWorkout,
                    lastWorkoutHasMetrics,
                    effortPointGraphYMax: effortYMax > 0 ?  effortYMax : 20,
                    effortPointGraphYMin: Math.min(...weeklyWorkoutStats.weeklyEffortPoints.graphData),
                },
            };
        }
        case REQUEST_WEEKLY_WORKOUT_STATS_FAILURE: {
            return {
                view: {
                    ...state.view,
                    weeklyWorkoutStatsIsLoading: false,
                },
                data: {
                    ...state.data,
                    weeklyWorkoutStats: null,
                    hasLastWorkout: false,
                    lastWorkoutHasMetrics: false,
                },
            };
        }
        case RELOAD_SCAN_STATS_FOR_DASHBOARD: {
            const scanStats = action.payload.scanStats && [action.payload.scanStats.totalBodyWeight, action.payload.scanStats.fat, action.payload.scanStats.muscleMass];
            const lastScanDate = (action.payload.scanStats && action.payload.scanStats.scanDate) && moment(action.payload.scanStats.scanDate).format('DD MMM YYYY');

            return {
                view: {
                    ...state.view,
                    lastScanDate,
                },
                data: {
                    ...state.data,
                    dashboard: {
                        ...state.data.dashboard,
                        scanStats,
                    }
                }
            }
        }
        case REQUEST_SCAN_STAT_DATES_SUCCESS: {
            const scanStats = action.payload.scanStats;
            const scanStatDates = scanStats
                .filter(({ invalid }) => !invalid)
                .sort((scanA, scanB) => moment(scanB.dateOfScan) - moment(scanA.dateOfScan))
                .map(({ dateOfScan }) => ({
                    displayName: moment(dateOfScan).format('D MMMM YYYY'),
                    value: moment(dateOfScan),
                }));

            return {
                view: {
                    ...state.view,
                    scanStatDates,
                },
                data: {
                    ...state.data,
                }
            }
        }
        case REQUEST_BODY_METRIC_STATS_REQUEST: {
            return {
                view: {
                    ...state.view,
                    bodyMetricStatsIsLoading: true,
                },
                data: {
                    ...state.data,
                },
            };
        }
        case REQUEST_BODY_METRIC_STATS_SUCCESS:
        case REQUEST_SAVE_BODY_SCALE_SCAN_SUCCESS: {
            const bodyMetricSet = action.payload.bodyMetricSet;

            return {
                view: {
                    ...state.view,
                    bodyMetricStatsIsLoading : false,
                    isLoadingHealth: false,
                },
                data: {
                    ...state.data,
                    bodyMetricSet: makeDates(bodyMetricSet),
                    bodyMetricStats: {},
                },
            };
        }
        case LOAD_TRACKING_DATA_FOR_DASHBOARD: {
          const bodyMetricSet = action.payload.bodyMetricSet;
          return {
            view: {
              ...state.view,
              bodyMetricStatsIsLoading : false,
              isLoadingHealth: false,
            },
            data: {
              ...state.data,
              bodyMetricSet: makeDates(bodyMetricSet),
              bodyMetricStats: {},
            }
          };
        }
        case REMOVE_TARGET_SUCCESS: {
          const bodyMetricSet = action.payload.bodyMetricSet;
          return {
            view: {
              ...state.view,
              bodyMetricStatsIsLoading : false,
              isLoadingHealth: false,
            },
            data: {
              ...state.data,
              bodyMetricSet: makeDates(bodyMetricSet),
              bodyMetricStats: {},
            },
          };
        }
        case REQUEST_BODY_METRIC_STATS_FAILURE: {
          return {
            view: {
              ...state.view,
              bodyMetricStatsIsLoading : false,
              bodyMetricStatsLoadError : action.payload,
            },
            data: {
              ...state.data,
              bodyMetricStats : {},
            },
          };
        }
        case LOAD_LEADERBOARDS_REQUEST: {
          const shouldShowLoaderForLeaderboards = !state.data.leaderboards;
          return {
            view: {
              ...state.view,
              isLoadingLeaderboards: shouldShowLoaderForLeaderboards,
            },
            data: {
              ...state.data,
            },
          };
        }
        case LOAD_LEADERBOARDS_SUCCESS: {
          return {
            view: {
              ...state.view,
              isLoadingLeaderboards: false,
            },
            data: {
              ...state.data,
              leaderboards: action.payload,
            },
          };
        }
        case LOAD_LEADERBOARDS_FAILURE: {
          return {
            view: {
              ...state.view,
              isLoadingLeaderboards : false,
              loadingLeaderboardsError: action.payload,
            },
            data: {
              ...state.data,
            },
          };
        }
        case LOAD_INACTIVE_LEADERBOARDS_REQUEST: {
            return {
              view: {
                ...state.view,
                isLoadingInactiveLeaderboards: true,
              },
              data: {
                ...state.data,
              },
            };
          }
          case LOAD_INACTIVE_LEADERBOARDS_SUCCESS: {
            return {
              view: {
                ...state.view,
                isLoadingInactiveLeaderboards: false,
              },
              data: {
                ...state.data,
                inactiveLeaderboards: action.payload,
              },
            };
          }
          case LOAD_INACTIVE_LEADERBOARDS_FAILURE: {
            return {
              view: {
                ...state.view,
                isLoadingInactiveLeaderboards : false,
                loadingInactiveLeaderboardsError: action.payload,
              },
              data: {
                ...state.data,
              },
            };
          }
          case LOAD_USER_BREAKDOWN_REQUEST: {
            return {
              view: {
                ...state.view,
                isLoadingUserBreakdown: true,
              },
              data: {
                ...state.data,
              },
            };
          }
          case LOAD_USER_BREAKDOWN_SUCCESS: {
            return {
              view: {
                ...state.view,
                isLoadingUserBreakdown: false,
              },
              data: {
                ...state.data,
                userBreakdown: action.payload,
              },
            };
          }
          case LOAD_USER_BREAKDOWN_FAILURE: {
            return {
              view: {
                ...state.view,
                isLoadingUserBreakdown : false,
                isLoadingUserBreakdownError: action.payload,
              },
              data: {
                ...state.data,
              },
            };
          }
      case OPT_OUT_OF_LEADERBOARD: {
        return {
          view: {
            ...state.view,
            isLeaderboardOptOutModalVisible: true,
          },
          data: {
            ...state.data,
            leaderboardToOptOutOf: action.payload.leaderboard,
          },
        };
      }
      case CLOSE_OPT_OUT_LEADERBOARD_MODAL: {
        return {
          view: {
            ...state.view,
            isLeaderboardOptOutModalVisible: false,
          },
          data: {
            ...state.data,
          },
        };
      }
      case OPT_OUT_OF_LEADERBOARD_REQUEST: {
        return {
          view: {
            ...state.view,
            isOptingOutOfLeaderboard: true,
          },
          data: {
            ...state.data,
          },
        };
      }
      case OPT_OUT_OF_LEADERBOARD_SUCCESS: {
        return {
          view: {
            ...state.view,
            isLeaderboardOptOutModalVisible: false,
            isOptingOutOfLeaderboard: false,
            leaderboardToOptOutOf: null,
          },
          data: {
            ...state.data,
          },
        };
      }
      case OPT_OUT_OF_LEADERBOARD_FAILURE: {
        return {
          view: {
            ...state.view,
            isLeaderboardOptOutModalVisible: false,
            isOptingOutOfLeaderboard: false,
          },
          data: {
            ...state.data,
          },
        };
      }
        default:
            return state;
    }
};
